var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWise(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 1000 226.4",
    style: {
      enableBackground: "new 0 0 1000 226.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#2e4369}")), /*#__PURE__*/React.createElement("g", {
    id: "Blue_Navy"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wise_7_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1000 99c0-58.1-40.5-99-97.2-99-72.2 0-120.6 52.5-120.6 127.4 0 58.5 40.9 99 98.6 99 52.5 0 91.6-25.4 107.7-65.8h-58.3c-7.7 12.6-24.2 20.5-44.3 20.5-31 0-50.3-20.5-52.1-49.6h163.1c1.9-11.1 3.1-20.5 3.1-32.5zm-161.9-6.8c5.2-26.7 31.2-48 62.5-48 27.1 0 47.6 19.8 47.6 48H838.1zM625.5 221.1l10.5-55.8c32 6.4 36.8-11.6 45.1-55l4.1-21.5C696.8 28.2 720.3-2 787.3 6.1L776.7 62c-32-6.4-37.6 17.8-44.7 55.4l-4.1 21.5c-11.6 61.3-35.8 90.4-102.4 82.2zM547.3 221.3 586.8 5.2h52l-39.3 216.1zM248.8 5.2h50.6l16.4 156.3L382.1 5.2h50.1l17.6 157.9L513.7 5.2h50.4l-91.6 216.1h-57.3L396.6 72.6l-63.3 148.7h-55.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "FF_7_",
    style: {
      fill: "#00b9ff"
    },
    d: "M60 62.5 0 119.9h102.1l10.6-25H61l32.3-32.4-18.7-32.3h87.7l-81 191.1h30.4L203.3 5.2h-177z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWise);
export default __webpack_public_path__ + "static/media/wise.9ffe1345d141b316ac4cd63baaaf4990.svg";
export { ForwardRef as ReactComponent };